import React, { Component } from 'react'
import store from '../../stores/storeConfig'
import { imageAddress } from '../../utils/useful'
import * as actions from '../../stores/actionsList'
import HttpServices from '../../utils/Http.services'


export default class WaitingCall extends Component {
    state = {
        voicecall: { profile: '/assets/images/avatar-voice-call.jpg', name: 'Corey Culhane' }
    }
    reject = () => {
        let data = this.props.data
        HttpServices.request('rejectCall', data, (fetchResult, fetchError) => {
            store.dispatch(actions.removeOutgoingCall([data]))
        })
    }
    componentDidMount() {
        this.checkAnswer()
    }
    checkAnswer = () => {
        let data = this.props.data
        setTimeout(() => {
            store.dispatch(actions.removeOutgoingCall([data]))
        }, 30000);
    }
    render() {
        let voicecall = this.state.voicecall
        return (
            <div className='voice-call flexcc br-20 blur-bg box-shadow-widgets p-2'>
                <div className='flexcb w-100'>
                    <div className='flexcc'>
                        <div className='img-container br-10'>
                            <img className='br-15 w-100 h-100' src={imageAddress(this.props.data.receiver.image, 'profile')} alt="" />
                        </div>
                        <div className='mld-3'>
                            {console.log('this.props.data.receiver', this.props.data.receiver)}
                            <p className='font-size-15 weight-500' style={{ color: "#555", overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis", maxWidth: "180px" }}>{this.props.data.receiver.name}</p>
                            <p className='font-size-10 color-green mt-1'>Voice Calling...</p>
                        </div>
                    </div>
                    <div className='flexc'>
                        <button className='flexcc' onClick={() => this.reject()}>
                            <img width={35} height={35} className='br-50 mx-2' src="/assets/icons/widgets/end-call.svg" alt="" />
                        </button>
                    </div>
                </div>
            </div>
        )
    }
}
